import React from "react";
import { Image } from "react-bootstrap";

const SubscribedContentModal = (props) => {
  return (
    <div className="chat-crown show">
      <button
        type="button"
        className="btn-link closefilebtn"
        onClick={() => props.setSubscribeShow(false)}
        titel='close file button'
      >
        <Image src="https://d9apl513jlx0u.cloudfront.net/public_assets/public/assets/images/icons/closebtn-subscribe.svg" alt="close subscribe" />
      </button>
      <div className="chatsubscriber">
        <div className="crownicon">
          <Image src="https://d9apl513jlx0u.cloudfront.net/public_assets/public/assets/images/icons/clarity_crown-solid.svg" alt="chat subscriber" />
        </div>
        <p>
          Hence, You never subscribed with Jasmine Rosie you will have to pay $1
          per message
        </p>
        <a href="#" className="btn btn-primary" aria-label='subscribe'>
          <Image src="/assets/images/icons/ant-design_user-add-outlined.svg" alt="subscribe" />
          Subscribe for $100
        </a>
        <a href="#" className="btn btn-primary" aria-label='start chat'>
          <Image src="/assets/images/icons/fluent_chat-32-regular.svg" alt="start chat" />
          Start chat with $1
        </a>
      </div>
    </div>
  );
};


export default SubscribedContentModal;
